import { Component, Input } from '@angular/core';
import { Airport } from '../models/airport.model';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { MatDialog, MatDialogConfig, MatSnackBar } from '@angular/material';
import { EditOverviewComponent } from '../edit-overview/edit-overview.component';
import { EditIslandOverviewComponent } from '../edit-island-overview/edit-island-overview.component';
import { Router } from '@angular/router';
import { SuggestAChangeComponent } from '../../shared/suggest-a-change/suggest-a-change.component';


@Component({
  selector: 'app-overview-header',
  templateUrl: './overview-header.component.html',
  styleUrls: ['./overview-header.component.scss']
})
export class OverviewHeaderComponent {
  @Input() airport: Airport;
  editModeSet = false;

  constructor (private _toggleService: EditToggleService,
               public _snackBar: MatSnackBar,
               private _editAirportOverviewDialog: MatDialog,
               private _editIslandAirportOverviewDialog: MatDialog,
               private _suggestAChangeDialog: MatDialog,
               private _router: Router) {
    this._toggleService.toggleEmitter.subscribe(isOn => {
      this.editModeSet = isOn;
    });
  }

  get website(): string {
    const website = this.airport.website || '';
    if (website.indexOf('http://') >= 0 || website.indexOf('https://') >= 0) {
      return website;
    } else {
      return 'http://' + website;
    }
  }

  getWebcamCount(): number {
    let webcamCount = this.airport.webcams.length;
    this.airport.businesses.forEach( (business) => {
      business.webcams.forEach( (businessWebcam) => {
        webcamCount++;
      });
    });
    return webcamCount;
  }

  navigateToWx() {
    let tempUrl = this._router.url;
    if (this._router.url.indexOf('#') > 0) {
      tempUrl = this._router.url.substr(0, tempUrl.indexOf('#'));
    }
    this._router.navigate([tempUrl], {fragment: 'wx'});
  }

  get identifier(): string {
    if (this.airport.identifier != null && this.airport.identifier.toUpperCase().startsWith('ZZ')) {
      return '';
    } else {
      return '(' + this.airport.identifier + ')';
    }
  }

  openEditWebsiteDialog() {
    const dialogConfig = new MatDialogConfig();
    const ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '60%';
    dialogConfig.data = {
      airportID: this.airport.airportId,
      website: this.airport.website
    };
    dialogConfig.width = '60%';
    const dialogRef = this._editAirportOverviewDialog.open(EditOverviewComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((isUpdated) => {
      if (!isUpdated) { return; } // required to handle backdrop click.
      if (isUpdated.cancelBtnClicked) { return; }
      // isUpdated.success will be false if there is an error during any of the api calls.
      if (isUpdated.success) {
          this.airport.website = isUpdated.website;
          this._snackBar.open('Website', 'Updated', {
            duration: 2000
          });
      } else {
        this._snackBar.open(ERROR_MSG, 'Error', {
          duration: 6000
        });
      }
    });
  }

  openEditIslandOverviewDialog() {
    const dialogConfig = new MatDialogConfig();
    const ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '60%';
    dialogConfig.data = {
      airport: this.airport
    };
    dialogConfig.width = '60%';
    const dialogRef = this._editIslandAirportOverviewDialog.open(EditIslandOverviewComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((isUpdated) => {
      if (!isUpdated) { return; } // required to handle backdrop click.
      if (isUpdated.cancelBtnClicked) { return; }
      // isUpdated.success will be false if there is an error during any of the api calls.
      if (isUpdated.success) {
        this.airport = isUpdated.airport;
        this._snackBar.open('Airport Overview', 'Updated', {
          duration: 2000
        });
      } else {
        this._snackBar.open(ERROR_MSG, 'Error', {
          duration: 6000
        });
      }
    });
  }

  openSuggestAChangeDialog() {
    const dialogConfig = new MatDialogConfig();
    const ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '35%';
    dialogConfig.data = {
      airportID: this.airport.airportId,
      airportAbbrev: this.airport.faaId != null ? this.airport.faaId : this.airport.icaoId
    };
    const dialogRef = this._suggestAChangeDialog.open(SuggestAChangeComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((isUpdated) => {
      if (!isUpdated) { return; } // required to handle backdrop click.
      if (isUpdated.cancelBtnClicked) { return; }
      // isUpdated.success will be false if there is an error during any of the api calls.
      if (isUpdated.success) {
        this._snackBar.open('The information you have provided has been forwarded to the AOPA Airport Directory team and ' +
          'will be reviewed as soon as possible. Thank you!', 'Success', {
          duration: 6000
        });
      } else {
        this._snackBar.open(ERROR_MSG, 'Error', {
          duration: 6000
        });
      }
    });
  }
}
